(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["creator-program"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-mg-cp]');
  if (!root) return;

  var howSection = root.querySelector('[data-mg-cp-how]');
  var howPanel = root.querySelector('[data-mg-cp-how-panel]');
  var howTriggers = root.querySelectorAll('[data-mg-cp-how-trigger]');

  function setHowOpen(open) {
    if (!howSection || !howPanel) return;
    howSection.classList.toggle('mg-cp__how--open', open);
    howPanel.hidden = !open;
    howTriggers.forEach(function (btn) {
      if (btn.classList.contains('mg-cp__how-toggle')) {
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
    });
  }

  function openHowItWorks(scroll) {
    setHowOpen(true);
    if (scroll !== false && howSection) {
      howSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  howTriggers.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (howSection && howSection.classList.contains('mg-cp__how--open')) {
        if (btn.classList.contains('mg-cp__how-toggle')) {
          setHowOpen(false);
          return;
        }
      }
      openHowItWorks(true);
    });
  });

  var wizard = root.querySelector('[data-mg-cp-wizard]');
  if (!wizard) return;

  var form = root.querySelector('#CreatorProgramForm');
  var bodyField = form.querySelector('#CreatorProgramBody');
  var panels = wizard.querySelectorAll('[data-step-panel]');
  var indicators = wizard.querySelectorAll('[data-step-indicator]');
  var summaryEl = wizard.querySelector('[data-mg-cp-summary]');

  function getValue(id) {
    var el = form.querySelector('#' + id);
    return el && el.value ? el.value.trim() : '';
  }

  function getCheckedValues(selector) {
    return Array.prototype.slice.call(form.querySelectorAll(selector))
      .filter(function (input) { return input.checked; })
      .map(function (input) { return input.value; });
  }

  function getRadioValue(name) {
    var checked = form.querySelector('input[name="' + name + '"]:checked');
    return checked ? checked.value : '';
  }

  function showError(step, message) {
    var err = wizard.querySelector('[data-error-step="' + step + '"]');
    if (!err) return;
    err.textContent = message;
    err.hidden = !message;
  }

  function goToStep(n) {
    panels.forEach(function (panel) {
      var step = parseInt(panel.dataset.stepPanel, 10);
      panel.hidden = step !== n;
      panel.classList.toggle('mg-cp__panel--active', step === n);
    });
    indicators.forEach(function (ind) {
      var step = parseInt(ind.dataset.stepIndicator, 10);
      ind.classList.toggle('mg-cp__step--active', step === n);
      ind.classList.toggle('mg-cp__step--done', step < n);
    });
    if (n === 5) updateSummary();
    wizard.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function updatePlatformFields() {
    wizard.querySelectorAll('[data-platform-toggle]').forEach(function (toggle) {
      var key = toggle.dataset.platformToggle;
      var fieldWrap = wizard.querySelector('[data-platform-field="' + key + '"]');
      if (!fieldWrap) return;
      fieldWrap.hidden = !toggle.checked;
      if (!toggle.checked) {
        var input = fieldWrap.querySelector('input');
        if (input) input.value = '';
      }
    });
  }

  function validateStep2() {
    var name = getValue('CreatorProgram-name');
    if (!name) {
      showError(2, 'Bitte gib deinen Vor- und Nachnamen an.');
      return false;
    }
    showError(2, '');
    return true;
  }

  function validateStep3() {
    var toggles = wizard.querySelectorAll('[data-platform-toggle]:checked');
    if (!toggles.length) {
      showError(3, 'Bitte wähle mindestens eine Plattform aus.');
      return false;
    }

    for (var i = 0; i < toggles.length; i++) {
      var k = toggles[i].dataset.platformToggle;
      var inp = form.querySelector('[data-mg-cp-field="' + k + '"]');
      if (!inp || !inp.value.trim()) {
        showError(3, 'Bitte gib für jede gewählte Plattform einen Username oder Link an.');
        return false;
      }
    }

    showError(3, '');
    return true;
  }

  function validateStep4() {
    if (!getRadioValue('mg_cp_reach')) {
      showError(4, 'Bitte wähle deine ungefähre Reichweite.');
      return false;
    }
    if (!getCheckedValues('[data-mg-cp-field="content"]').length) {
      showError(4, 'Bitte wähle mindestens einen Content-Fokus.');
      return false;
    }
    if (!getRadioValue('mg_cp_brand_exp')) {
      showError(4, 'Bitte beantworte die Frage zu bisherigen Kooperationen.');
      return false;
    }
    showError(4, '');
    return true;
  }

  function platformLabel(key) {
    if (key === 'instagram') return 'Instagram';
    if (key === 'tiktok') return 'TikTok';
    if (key === 'youtube') return 'YouTube';
    return 'Andere';
  }

  function collectPlatforms() {
    var rows = [];
    wizard.querySelectorAll('[data-platform-toggle]:checked').forEach(function (toggle) {
      var key = toggle.dataset.platformToggle;
      var input = form.querySelector('[data-mg-cp-field="' + key + '"]');
      rows.push(platformLabel(key) + ': ' + (input && input.value.trim() ? input.value.trim() : '–'));
    });
    return rows.join('\n');
  }

  function updateSummary() {
    if (!summaryEl) return;
    var content = getCheckedValues('[data-mg-cp-field="content"]').join(', ') || '–';
    var bestPost = getValue('CreatorProgram-best-post');

    summaryEl.innerHTML =
      '<div class="mg-cp__summary-row"><span class="mg-cp__summary-label">Name</span>' + escapeHtml(getValue('CreatorProgram-name') || '–') + '</div>' +
      '<div class="mg-cp__summary-row"><span class="mg-cp__summary-label">Plattformen</span>' + escapeHtml(collectPlatforms()).replace(/\n/g, '<br>') + '</div>' +
      '<div class="mg-cp__summary-row"><span class="mg-cp__summary-label">Reichweite</span>' + escapeHtml(getRadioValue('mg_cp_reach') || '–') + '</div>' +
      '<div class="mg-cp__summary-row"><span class="mg-cp__summary-label">Content-Fokus</span>' + escapeHtml(content) + '</div>' +
      '<div class="mg-cp__summary-row"><span class="mg-cp__summary-label">Kooperationen</span>' + escapeHtml(getRadioValue('mg_cp_brand_exp') || '–') + '</div>' +
      (bestPost ? '<div class="mg-cp__summary-row"><span class="mg-cp__summary-label">Bester Beitrag</span>' + escapeHtml(bestPost) + '</div>' : '');
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function buildBody() {
    var lines = [
      'Creator Programm – Bewerbung',
      '',
      'Vor- und Nachname: ' + getValue('CreatorProgram-name'),
      '',
      'Plattformen:',
      collectPlatforms(),
      '',
      'Reichweite: ' + (getRadioValue('mg_cp_reach') || '–'),
      'Content-Fokus: ' + (getCheckedValues('[data-mg-cp-field="content"]').join(', ') || '–'),
      'Parfum-/Beauty-Kooperationen: ' + (getRadioValue('mg_cp_brand_exp') || '–')
    ];

    var bestPost = getValue('CreatorProgram-best-post');
    if (bestPost) lines.push('Bester Beitrag: ' + bestPost);

    lines.push('', 'E-Mail: ' + getValue('CreatorProgram-email'));

    var message = getValue('CreatorProgram-message');
    if (message) {
      lines.push('', 'Nachricht:', message);
    }

    return lines.join('\n');
  }

  wizard.querySelectorAll('[data-next-step]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var next = parseInt(btn.dataset.nextStep, 10);
      if (next === 3 && !validateStep2()) return;
      if (next === 4 && !validateStep3()) return;
      if (next === 5 && !validateStep4()) return;
      goToStep(next);
    });
  });

  wizard.querySelectorAll('[data-back-step]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      goToStep(parseInt(btn.dataset.backStep, 10));
    });
  });

  wizard.querySelectorAll('[data-platform-toggle]').forEach(function (toggle) {
    toggle.addEventListener('change', updatePlatformFields);
  });

  form.addEventListener('submit', function (event) {
    if (!validateStep2() || !validateStep3() || !validateStep4()) {
      event.preventDefault();
      if (!validateStep2()) goToStep(2);
      else if (!validateStep3()) goToStep(3);
      else if (!validateStep4()) goToStep(4);
      return;
    }

    var consent = form.querySelector('[data-mg-cp-consent]');
    if (consent && !consent.checked) {
      event.preventDefault();
      showError(5, 'Bitte akzeptiere die Datenschutzhinweise.');
      goToStep(5);
      return;
    }

    showError(5, '');
    if (bodyField) bodyField.value = buildBody();
  });

  if (form.querySelector('.mg-cp__alert--error')) {
    goToStep(5);
  }

  root.querySelectorAll('[data-mg-cp-how-apply]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var application = root.querySelector('#mg-cp-application');
      if (application) application.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (wizard) goToStep(2);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-review-submit"] && !Shopify.designMode) return;
  try {
    
(function () {
  const roots = document.querySelectorAll('[data-mg-crs]');
  if (!roots.length) return;

  roots.forEach(function (root) {
    const voucherCode = root.dataset.voucherCode || 'BEWERTUNG-MA9T';
    const lookupUrl = (root.dataset.lookupUrl || '/apps/mg-reviews/proxy/lookup').trim();
    const submitUrl = (root.dataset.submitUrl || '/apps/mg-reviews/proxy/submit').trim();
    const discountAmount = root.dataset.discountAmount || '30';
    const language = root.dataset.language || 'de';

    const saveCodeNote = language === 'en'
      ? 'Please save, copy, or take a screenshot of this code now — it will not be shown again and is not sent by email. Valid once per customer, combinable with order discounts.'
      : 'Bitte speichern, kopieren oder fotografieren Sie den Code jetzt — er wird nicht erneut angezeigt und nicht per E-Mail versendet. Einmalig gültig pro Kunde, kombinierbar mit Bestellrabatten.';

    let state = {
      email: '',
      firstName: '',
      lastNameInitial: '',
      displayName: '',
      orders: [],
      selectedProduct: null,
      rating: 0,
      reviewText: '',
      photoDataUrl: null
    };

    const panels = root.querySelectorAll('[data-step-panel]');
    const indicators = root.querySelectorAll('[data-step-indicator]');

    function goToStep(n) {
      panels.forEach(function (p) {
        const step = parseInt(p.dataset.stepPanel, 10);
        p.hidden = step !== n;
        p.classList.toggle('mg-crs__panel--active', step === n);
      });
      indicators.forEach(function (ind) {
        const step = parseInt(ind.dataset.stepIndicator, 10);
        ind.classList.toggle('mg-crs__step--active', step === n);
        ind.classList.toggle('mg-crs__step--done', step < n);
      });
    }

    function formatDisplayName(first, last) {
      const initial = last ? last.charAt(0).toUpperCase() + '.' : '';
      return (first || '') + (initial ? ' ' + initial : '');
    }

    function getProductCatalog() {
      const el = root.querySelector('[data-mg-product-catalog]');
      if (!el) return [];
      try {
        return JSON.parse(el.textContent).products || [];
      } catch (e) {
        return [];
      }
    }

    function findProductImage(title, handle) {
      const catalog = getProductCatalog();
      const match = catalog.find(function (p) {
        return (handle && p.handle === handle) || p.title === title;
      });
      return match ? match.image : '';
    }

    function formatOrderDate() {
      const d = new Date();
      return d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
    }

    function getCustomerOrdersPayload() {
      const el = root.querySelector('[data-mg-customer-orders]');
      if (!el) return null;
      try {
        const parsed = JSON.parse(el.textContent);
        return parsed && parsed.email ? parsed : null;
      } catch (e) {
        return null;
      }
    }

    function normalizeLookupResponse(data, email) {
      const fallbackName = email && email.includes('@') ? email.split('@')[0] : 'Kunde';
      return {
        firstName: data.firstName || '',
        lastName: data.lastName || '',
        displayName:
          (data.displayName || formatDisplayName(data.firstName, data.lastName) || '').trim() ||
          fallbackName,
        orders: (data.orders || []).map(function (item) {
          return {
            id: item.id || item.handle,
            handle: item.handle,
            title: item.title,
            date: item.date,
            image: item.image || ''
          };
        })
      };
    }

    async function lookupOrder(email) {
      const normalizedEmail = email.trim().toLowerCase();
      const customerData = getCustomerOrdersPayload();

      if (customerData && customerData.email.toLowerCase() === normalizedEmail) {
        if (customerData.orders && customerData.orders.length) {
          return normalizeLookupResponse(customerData, customerData.email);
        }
      } else if (customerData && customerData.email.toLowerCase() !== normalizedEmail) {
        throw new Error('Die E-Mail-Adresse stimmt nicht mit Ihrem Kundenkonto überein. Bitte melden Sie sich mit Ihrer Bestell-E-Mail an.');
      }

      if (lookupUrl) {
        const res = await fetch(lookupUrl + '?email=' + encodeURIComponent(email));
        const data = await res.json();
        if (!res.ok) throw new Error(data.error || 'Keine Bestellung mit dieser E-Mail gefunden.');
        return normalizeLookupResponse(data, email);
      }

      throw new Error('Bitte melden Sie sich mit Ihrer Bestell-E-Mail an, um Ihre Bestellung zu laden.');
    }

    const isLoggedIn = root.dataset.isLoggedIn === 'true';

    function resolveCustomerName() {
      const name = (state.displayName || '').trim();
      if (name) return name;
      const first = (state.firstName || '').trim();
      if (first) return first;
      const email = (state.email || '').trim();
      if (email.includes('@')) return email.split('@')[0];
      return 'Kunde';
    }

    function applyCustomerSession(data, email) {
      state.email = email;
      state.firstName = data.firstName;
      state.lastNameInitial = data.lastName ? data.lastName.charAt(0) : '';
      state.displayName =
        (data.displayName || formatDisplayName(data.firstName, data.lastName) || '').trim() ||
        (email.includes('@') ? email.split('@')[0] : 'Kunde');
      state.orders = data.orders || [];
      root.querySelector('[data-customer-name]').textContent = state.displayName;
      renderOrders(state.orders);
      root.querySelector('[data-next-step="3"]').disabled = state.orders.length === 0;
    }

    async function initLoggedInSession() {
      const customerData = getCustomerOrdersPayload();
      const errEl = root.querySelector('[data-error-orders]');
      const loadingEl = root.querySelector('[data-loading-orders]');

      if (!customerData || !customerData.email) {
        if (errEl) {
          errEl.textContent = 'Bitte geben Sie Ihre Bestell-E-Mail ein oder melden Sie sich an.';
          errEl.hidden = false;
        }
        if (loadingEl) loadingEl.remove();
        return;
      }

      try {
        let data = normalizeLookupResponse(customerData, customerData.email);

        if (!data.orders.length) {
          data = await lookupOrder(customerData.email);
        }

        if (!data.orders.length) {
          throw new Error('Keine bewertbaren Produkte in Ihrer Bestellung gefunden.');
        }

        applyCustomerSession(data, customerData.email);
        if (loadingEl) loadingEl.remove();
        goToStep(2);
      } catch (err) {
        if (loadingEl) loadingEl.remove();
        if (errEl) {
          errEl.textContent = err.message || 'Bestellung konnte nicht geladen werden.';
          errEl.hidden = false;
        }
      }
    }

    async function startEmailLookup() {
      const emailInput = root.querySelector('[data-email-lookup]');
      const errEl = root.querySelector('[data-error-email-lookup]');
      const btn = root.querySelector('[data-email-lookup-btn]');
      const email = (emailInput?.value || '').trim().toLowerCase();

      if (errEl) errEl.hidden = true;
      if (!email) {
        if (errEl) {
          errEl.textContent = 'Bitte geben Sie Ihre Bestell-E-Mail ein.';
          errEl.hidden = false;
        }
        return;
      }

      if (btn) {
        btn.disabled = true;
        btn.textContent = 'Wird geladen …';
      }

      try {
        const data = await lookupOrder(email);
        applyCustomerSession(data, email);
        goToStep(2);
      } catch (err) {
        if (errEl) {
          errEl.textContent = err.message || 'Bestellung konnte nicht geladen werden.';
          errEl.hidden = false;
        }
      } finally {
        if (btn) {
          btn.disabled = false;
          btn.textContent = 'Bestellung laden';
        }
      }
    }

    function renderOrders(orders) {
      const list = root.querySelector('[data-order-list]');
      list.innerHTML = '';
      orders.forEach(function (item) {
        const el = document.createElement('div');
        el.className = 'mg-crs__order-item';
        el.dataset.orderId = item.id;
        const imgSrc = item.image || findProductImage(item.title, item.handle);
        const imgAlt = item.title ? item.title + ' Produktfoto' : 'Produktfoto';
        el.innerHTML =
          '<div class="mg-crs__order-img-wrap">' +
            '<img class="mg-crs__order-img" src="' + imgSrc + '" alt="' + imgAlt + '">' +
          '</div>' +
          '<div class="mg-crs__order-info">' +
            '<p class="mg-crs__order-title">' + item.title + '</p>' +
            '<p class="mg-crs__order-meta">Bestellt am ' + item.date + '</p>' +
          '</div>' +
          '<div class="mg-crs__order-radio"></div>';
        el.addEventListener('click', function () {
          list.querySelectorAll('.mg-crs__order-item').forEach(function (o) {
            o.classList.remove('mg-crs__order-item--selected');
          });
          el.classList.add('mg-crs__order-item--selected');
          state.selectedProduct = item;
          root.querySelector('[data-next-step="3"]').disabled = false;
        });
        list.appendChild(el);
      });
    }

    function updateSelectedProductLabels() {
      if (!state.selectedProduct) return;
      const label = 'Bewertung für: <strong>' + state.selectedProduct.title + '</strong>';
      const sel = root.querySelector('[data-selected-product]');
      const selPhoto = root.querySelector('[data-selected-product-photo]');
      if (sel) sel.innerHTML = label;
      if (selPhoto) selPhoto.innerHTML = label;
    }

    root.querySelector('[data-next-step="3"]').addEventListener('click', function () {
      if (!state.selectedProduct) return;
      updateSelectedProductLabels();
      goToStep(3);
    });

    root.querySelector('[data-next-step="4"]').addEventListener('click', function () {
      const reviewForm = root.querySelector('[data-form-review]');
      const errEl = root.querySelector('[data-error-review]');
      const text = reviewForm.review_text.value.trim();

      errEl.hidden = true;
      if (!state.rating) {
        errEl.textContent = 'Bitte wählen Sie eine Sterne-Bewertung.';
        errEl.hidden = false;
        return;
      }
      if (!text) {
        errEl.textContent = 'Bitte schreiben Sie eine kurze Bewertung.';
        errEl.hidden = false;
        return;
      }

      state.reviewText = text;
      updateSelectedProductLabels();
      goToStep(4);
      const photoPanel = root.querySelector('[data-step-panel="4"]');
      if (photoPanel) photoPanel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });

    root.querySelectorAll('[data-back-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        goToStep(parseInt(btn.dataset.backStep, 10));
      });
    });

    const starInput = root.querySelector('[data-star-input]');
    const ratingHidden = root.querySelector('[name="rating"]');
    starInput.querySelectorAll('[data-star]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const val = parseInt(btn.dataset.star, 10);
        state.rating = val;
        ratingHidden.value = val;
        starInput.querySelectorAll('[data-star]').forEach(function (b) {
          b.classList.toggle('mg-crs__star-btn--active', parseInt(b.dataset.star, 10) <= val);
        });
      });
    });

    function autoCropPhoto(img) {
      const targetRatio = 4 / 5;
      const srcRatio = img.width / img.height;
      let sw, sh, sx, sy;

      if (srcRatio > targetRatio) {
        sh = img.height;
        sw = sh * targetRatio;
        sx = (img.width - sw) / 2;
        sy = 0;
      } else {
        sw = img.width;
        sh = sw / targetRatio;
        sx = 0;
        sy = (img.height - sh) / 2;
      }

      const canvas = document.createElement('canvas');
      canvas.width = 800;
      canvas.height = 1000;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, sx, sy, sw, sh, 0, 0, canvas.width, canvas.height);
      return canvas.toDataURL('image/jpeg', 0.82);
    }

    function showPhotoPreview(dataUrl) {
      const preview = root.querySelector('[data-photo-preview]');
      const trigger = root.querySelector('[data-photo-trigger]');
      const loading = root.querySelector('[data-photo-loading]');
      const img = root.querySelector('[data-photo-img]');

      state.photoDataUrl = dataUrl;
      img.src = dataUrl;
      preview.hidden = false;
      trigger.hidden = true;
      trigger.style.visibility = '';
      loading.hidden = true;
    }

    function resetPhotoUpload() {
      state.photoDataUrl = null;
      const trigger = root.querySelector('[data-photo-trigger]');
      root.querySelector('[data-photo-preview]').hidden = true;
      trigger.hidden = false;
      trigger.style.visibility = '';
      root.querySelector('[data-photo-loading]').hidden = true;
    }

    function handlePhotoFile(file) {
      if (!file || !file.type.startsWith('image/')) return;

      const loading = root.querySelector('[data-photo-loading]');
      const trigger = root.querySelector('[data-photo-trigger]');
      loading.hidden = false;
      trigger.style.visibility = 'hidden';

      const reader = new FileReader();
      reader.onload = function (ev) {
        const img = new Image();
        img.onload = function () {
          try {
            showPhotoPreview(autoCropPhoto(img));
          } catch (err) {
            loading.hidden = true;
            trigger.style.visibility = '';
            root.querySelector('[data-error-photo]').textContent = 'Foto konnte nicht verarbeitet werden. Bitte versuchen Sie es erneut.';
            root.querySelector('[data-error-photo]').hidden = false;
          }
        };
        img.onerror = function () {
          loading.hidden = true;
          trigger.style.visibility = '';
        };
        img.src = ev.target.result;
      };
      reader.readAsDataURL(file);
    }

    const photoInput = root.querySelector('[data-photo-input]');
    photoInput.addEventListener('change', function (e) {
      const file = e.target.files[0];
      if (file) handlePhotoFile(file);
      e.target.value = '';
    });

    root.querySelector('[data-photo-change]').addEventListener('click', function () {
      photoInput.click();
    });

    root.querySelector('[data-photo-remove]').addEventListener('click', function () {
      resetPhotoUpload();
    });

    async function submitReview() {
      if (!state.email) {
        throw new Error('Bitte laden Sie zuerst Ihre Bestellung (Schritt 1 oder 2).');
      }
      if (!state.selectedProduct || !state.rating || !state.reviewText) {
        throw new Error('Bitte füllen Sie alle Schritte aus.');
      }

      const payload = {
        email: state.email,
        customerName: resolveCustomerName(),
        rating: state.rating,
        reviewText: state.reviewText,
        productName: state.selectedProduct.title,
        productHandle: state.selectedProduct.handle,
        photoDataUrl: state.photoDataUrl || ''
      };

      try {
        const res = await fetch(submitUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });

        const data = await res.json().catch(function () {
          return {};
        });

        if (res.ok) {
          return data;
        }

        if (res.status >= 500) {
          console.warn('Review API server error, using contact fallback', data);
          return submitReviewViaContact();
        }

        throw new Error(data.error || 'Bewertung konnte nicht gesendet werden. Bitte versuchen Sie es erneut.');
      } catch (apiErr) {
        if (apiErr instanceof TypeError) {
          console.warn('Review API network error, using contact fallback', apiErr);
          return submitReviewViaContact();
        }
        throw apiErr;
      }
    }

    async function submitReviewViaContact() {
      const fallbackForm = document.getElementById('mg-crs-contact-fallback');
      if (!fallbackForm) {
        throw new Error('Bewertung konnte nicht gesendet werden. Bitte versuchen Sie es später erneut.');
      }

      const stars = '★'.repeat(state.rating) + '☆'.repeat(5 - state.rating);
      const lines = [
        'NEUE KUNDENBEWERTUNG',
        '====================',
        '',
        'Kundenname: ' + resolveCustomerName(),
        'E-Mail: ' + state.email,
        'Produkt: ' + state.selectedProduct.title,
        'Sterne: ' + state.rating + '/5 ' + stars
      ];
      if (state.selectedProduct.handle) {
        lines.push('Produkt-Handle: ' + state.selectedProduct.handle);
      }
      if (state.selectedProduct.date) {
        lines.push('Bestellt am: ' + state.selectedProduct.date);
      }
      lines.push('', 'Bewertungstext:', state.reviewText);
      if (state.photoDataUrl) {
        lines.push('', 'Hinweis: Der Kunde hat ein Foto hochgeladen. Bitte kurz per E-Mail an ' + state.email + ' antworten und um Weiterleitung des Fotos bitten.');
      }

      const formData = new FormData(fallbackForm);
      formData.set('contact[email]', state.email);
      formData.set('contact[name]', state.displayName);
      formData.set('contact[body]', lines.join('\n'));

      const res = await fetch('/contact', {
        method: 'POST',
        body: formData,
        redirect: 'manual',
        credentials: 'same-origin'
      });

      if (res.status !== 0 && res.status !== 200 && res.status !== 302 && res.status !== 303) {
        throw new Error('Bewertung konnte nicht gesendet werden. Bitte versuchen Sie es erneut.');
      }

      return { voucherCode: voucherCode, discountAmount: discountAmount };
    }

    const submitBtn = root.querySelector('[data-submit-review]');
    submitBtn.addEventListener('click', async function () {
      const errEl = root.querySelector('[data-error-photo]');
      const btnText = submitBtn.querySelector('[data-btn-text]');
      const spinner = submitBtn.querySelector('[data-btn-spinner]');

      errEl.hidden = true;

      submitBtn.disabled = true;
      btnText.hidden = true;
      spinner.hidden = false;

      try {
        if (!state.selectedProduct || !state.rating || !state.reviewText) {
          throw new Error('Bitte füllen Sie alle Schritte aus.');
        }

        const result = await submitReview();

        root.querySelector('[data-voucher-code]').textContent = result.voucherCode || voucherCode;
        root.querySelector('[data-voucher-amount]').textContent = result.discountAmount || discountAmount;
        var noteEl = root.querySelector('[data-success-note]');
        if (noteEl) noteEl.textContent = saveCodeNote;

        root.querySelector('[data-copy-voucher]').onclick = function () {
          navigator.clipboard.writeText(root.querySelector('[data-voucher-code]').textContent);
          this.textContent = 'Kopiert!';
          setTimeout(function () {
            root.querySelector('[data-copy-voucher]').textContent = 'Code kopieren';
          }, 2000);
        };

        goToStep(5);
      } catch (err) {
        errEl.textContent = err.message || 'Ein Fehler ist aufgetreten.';
        errEl.hidden = false;
      } finally {
        submitBtn.disabled = false;
        btnText.hidden = false;
        spinner.hidden = true;
      }
    });

    const emailLookupBtn = root.querySelector('[data-email-lookup-btn]');
    const emailLookupInput = root.querySelector('[data-email-lookup]');
    if (emailLookupBtn) {
      emailLookupBtn.addEventListener('click', startEmailLookup);
    }
    if (emailLookupInput) {
      emailLookupInput.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          startEmailLookup();
        }
      });
    }

    if (isLoggedIn) {
      initLoggedInSession();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
